import * as React from 'react'

import {
  Box,
  Button,
  Card,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableRow,
  TextField,
  Typography
} from '@material-ui/core'
import { FlexHorizontal, Spacer } from '@vestaboard/installables'

import { SelectMessageSet } from '../components/SelectMessageSet'
import { useCreateMarketplaceListing } from '../hooks/useCreateMarketplaceListing'
import { useHistory } from 'react-router'
import { useNewMarketplaceListingQuery } from '../hooks/useNewMarketplaceListingQuery'

type NewMarketplaceListingContainerProps = INewMarketplaceListingContainerProps

interface INewMarketplaceListingContainerProps {}

export const NewMarketplaceListingContainer: React.FC<NewMarketplaceListingContainerProps> = props => {
  const { data } = useNewMarketplaceListingQuery()
  const history = useHistory()
  const [mutate] = useCreateMarketplaceListing()

  const [selectedMessageSet, setSelectedMessageSet] = React.useState(null as string | null)
  const [selectedInstallable, setSelectedInstallable] = React.useState('')
  const [title, setTitle] = React.useState('')
  const [description, setDescription] = React.useState('')

  const [, setSubmitting] = React.useState(false)

  const submit = async () => {
    if (!selectedInstallable || !title || !description) {
      return
    }

    setSubmitting(true)
    await mutate({
      variables: {
        messageSet: selectedMessageSet,
        installable: selectedInstallable,
        title,
        description,
        releaseDate: new Date().getTime()
      }
    })

    setSubmitting(false)
    history.push('/marketplace-listings')
  }

  return (
    <Box>
      <FlexHorizontal spaceBetween>
        <Typography variant='h4'>Create Marketplace Listing</Typography>
      </FlexHorizontal>
      <Spacer size='extraLarge' />
      <Card style={{ width: 500 }}>
        <Table>
          <TableRow>
            <TableCell>Message set</TableCell>
            <TableCell>
              <SelectMessageSet messageSet={selectedMessageSet} setMessageSet={setSelectedMessageSet} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Installable</TableCell>
            <TableCell>
              <Select
                fullWidth
                variant='outlined'
                value={selectedInstallable}
                onChange={e => setSelectedInstallable(e.target.value as string)}>
                {data?.publicInstallables
                  .sort((l1, l2) => (l1.title ?? '').localeCompare(l2.title ?? ''))
                  .map(i => (
                    <MenuItem value={i.id}>{i.title}</MenuItem>
                  ))}
              </Select>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>
              <TextField variant='outlined' value={title} onChange={e => setTitle(e.target.value)} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell>
              <TextField
                variant='outlined'
                multiline
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </TableCell>
          </TableRow>
        </Table>
      </Card>
      <Spacer size='extraLarge' />
      <FlexHorizontal>
        <Button
          size='large'
          variant='contained'
          onClick={() => {
            history.push('/marketplace-listings')
          }}>
          Cancel
        </Button>
        <Box width={24} />
        <Button onClick={() => submit()} variant='contained' size='large' color='primary'>
          Create
        </Button>
      </FlexHorizontal>
    </Box>
  )
}
